import { render, staticRenderFns } from "./screenList-1.vue?vue&type=template&id=06064204&scoped=true"
import script from "./screenList-1.vue?vue&type=script&lang=js"
export * from "./screenList-1.vue?vue&type=script&lang=js"
import style0 from "./screenList-1.vue?vue&type=style&index=0&id=06064204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06064204",
  null
  
)

export default component.exports